export const PledgeEstateTexts = {
  submitButtonLabel: 'Отправить заявку',
  popupHeader: 'Информация о залоге',
};
